import * as React from "react";
import { ComponentType } from "react";
import { delay } from "../helpers/general";

export const AsyncUsersPage = React.lazy(() => {
  return Promise.all([import(/* webpackChunkName: "UsersPage" */ "../pages/UsersPage"), delay(500)]).then(
    ([moduleExports]) => moduleExports as { default: ComponentType<any> }
  );
});

export const AsyncUserPage = React.lazy(() => {
  return Promise.all([import(/* webpackChunkName: "UserPageStore" */ "../pages/UserPage"), delay(500)]).then(
    ([moduleExports]) => moduleExports as { default: ComponentType<any> }
  );
});

export const AsyncPermissionsPage = React.lazy(() => {
  return Promise.all([import(/* webpackChunkName: "PermissionsPage" */ "../pages/PermissionsPage"), delay(500)]).then(
    ([moduleExports]) => moduleExports as { default: ComponentType<any> }
  );
});

export const AsyncServerErrorPage = React.lazy(() => {
  return Promise.all([import(/* webpackChunkName: "ServerErrorPage" */ "../pages/ServerErrorPage"), delay(500)]).then(
    ([moduleExports]) => moduleExports as { default: ComponentType<any> }
  );
});

// export const AsyncNotFoundPage = React.lazy(() => {
//   return Promise.all([import(/* webpackChunkName: "NotFoundPage" */ "../pages/NotFoundPage"), delay(500)]).then(
//     ([moduleExports]) => moduleExports as { default: ComponentType<any> }
//   );
// });
